import Phaser from 'phaser';

// Boot scene: load ONLY the splash image (+ fonts), then hand off to
// PreloadScene. Keeping this tiny means the splash appears almost immediately
// instead of after the full asset download.
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  preload(): void {
    const base = (import.meta as unknown as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
    this.load.setPath(`${base}assets`);
    this.load.image('loadscreen', 'images/loadscreen.png');
  }

  create(): void {
    // Fire-and-forget font warmup; PreloadScene/Main render text once ready.
    void this.ensureFontsLoaded();
    this.scene.start('Preload');
  }

  private async ensureFontsLoaded(): Promise<void> {
    if (typeof document === 'undefined' || !document.fonts) return;
    try {
      await Promise.all([
        document.fonts.load('48px SnackerComic'),
        document.fonts.load('48px SnackerComicOutline'),
        document.fonts.load('48px Fredoka'),
      ]);
      await document.fonts.ready;
    } catch {
      // ignore — fall back to whatever the browser has.
    }
  }
}
